import React from 'react';
import {useFormsOfflineAutoSession} from './offline/useFormsOfflineAutoSession';

export interface FormsOfflineBoundaryProps {
  children: React.ReactNode;
}

// Wraps every Forms page so the auto-cached offline session starts once the user
// is signed in, regardless of which Forms page they land on first.
export const FormsOfflineBoundary: React.FC<FormsOfflineBoundaryProps> = ({
  children,
}) => {
  useFormsOfflineAutoSession();
  return <>{children}</>;
};
